import React, { useEffect, useState, useRef } from "react";
import { ReactComponent as Communicate } from "../../../assets/icons/Communicate.svg";
import { ReactComponent as Avatar } from "../../../assets/icons/Avatar.svg";
import { ReactComponent as Copy } from "../../../assets/icons/Copyy.svg";
import { ReactComponent as ArrowLeftIcon } from "../../../assets/icons/ArrowLeft.svg";
import { ReactComponent as MicrophoneIcon } from "../../../assets/icons/Microphone.svg";
import { ReactComponent as MuteIcon } from "../../../assets/icons/Mute.svg";
import { ReactComponent as EndCallIcon } from "../../../assets/icons/EndCall.svg";
const { v4: uuidv4 } = require('uuid');

import { useNavigate } from 'react-router-dom';
import "./showScript.scss";
import { getSymblAccessToken } from "../../../services/callScore";
import { getConnectedAudioData, talkToLLM } from "../../../services/realTimeAssist";
import { REALTIME_ASSIST_COMPONENTS } from "../../../data/realTimeAssistComponents";

let customerClient;
let agentClient;
let audioContext;
let realtimeSessionId = uuidv4();
let userType = 'agent';
let messageTimeout;
let mediaStream; // Reference to the media stream
let runningThis = false;

const attachAndHandleAudioData = (client, scriptProcessor, audioContext) => {
    scriptProcessor.onaudioprocess = (event) => {
        const buffer = event.inputBuffer.getChannelData(0);
        const audioBuffer = audioContext.createBuffer(1, buffer.length, audioContext.sampleRate);
        audioBuffer.copyToChannel(buffer, 0);

        const bufferData = audioBuffer.getChannelData(0);
        const encodedBuffer = new Int16Array(bufferData.length);
        for (let i = 0; i < bufferData.length; i++) {
            encodedBuffer[i] = bufferData[i] * 32767;
        }

        if (client.readyState === WebSocket.OPEN) {
            client.send(encodedBuffer.buffer);
        }
    };
};

const sendConnectedAudio = (client) => {
    getConnectedAudioData().then(buffer => {
        console.log("Sending buffer data", buffer);
        //client.send(buffer);
    });
};

const startWebSocketAndMic = async (setData, setIsConnecting, userType, setClosedCaption, conversationRef, interactionType, scriptTitle, callContext, muteMic, isCoworkerConnected, setIsCoworkerConnected, setStartedSpeaking, selectedAssistantNames,utteranceRef,conversationId) => {
    runningThis = true;
    const SYMBL_ACCESS_TOKEN = await getSymblAccessToken();
    const production = 'wss://api.symbl.ai';
    const symblEndpoint = `${production}/v1/streaming/${realtimeSessionId}`;
    let scriptProcessor;
    isCoworkerConnected=isCoworkerConnected;

    const client = new WebSocket(symblEndpoint, SYMBL_ACCESS_TOKEN);
    if (userType === 'customer') customerClient = client;
    if (userType === 'agent') agentClient = client;

    client.onopen = () => {
        console.log(`${userType} WebSocket Client Connected`);
        runningThis = false;

        navigator.mediaDevices.getUserMedia({ audio: true }).then(stream => {
            mediaStream = stream; // Save the media stream reference
            audioContext = new (window.AudioContext || window.webkitAudioContext)();
            let mediaStreamSource = audioContext.createMediaStreamSource(stream);

            let analyser = audioContext.createAnalyser();
            analyser.fftSize = 256;

            scriptProcessor = audioContext.createScriptProcessor(256, 1, 1);
            scriptProcessor.connect(audioContext.destination);

            mediaStreamSource.connect(analyser);
            analyser.connect(scriptProcessor);

            // Mute Microphone as soon as we connect
            muteMicrophone(muteMic);

            console.log(`${userType} Sending start request to Client`);

            client.send(JSON.stringify({
                type: 'start_request',
                id: realtimeSessionId,
                insightTypes: [],
                config: {
                    confidenceThreshold: 0.5,
                    timezoneOffset: 480,
                    speechRecognition: {
                        encoding: 'LINEAR16',
                        sampleRateHertz: 48000,
                    },
                    sentiment: false,
                    trackers: {
                        interimResults: false,
                        enableAllTrackers: false
                    }
                },
                speaker: {
                    email: userType === 'customer' ? "customer-test-email@Symbl.ai" : "agent-test-email@Symbl.ai",
                    userId: userType === 'customer' ? "customer-test-email@Symbl.ai" : "agent-test-email@Symbl.ai",
                    name: userType
                },
                handlers: {
                    onSpeechDetected: data => {
                        console.log('onSpeechDetected', JSON.stringify(data));
                    },
                    onMessageResponse: data => {
                        console.log('onMessageResponse', JSON.stringify(data));
                    },
                    onInsightResponse: data => {
                        console.log('onInsightResponse', JSON.stringify(data));
                    },
                    onTrackerResponse: data => {
                        console.log('onTrackerResponse', JSON.stringify(data));
                    },
                    onTopicResponse: data => {
                        console.log('onTopicResponse', JSON.stringify(data));
                    },
                },
            }));
        }).catch(error => {
            console.error('Error accessing microphone', error);
        });
    };

    client.onerror = (error) => {
        console.error('WebSocket Error: ', error);
        runningThis = false;
    };

    client.onclose = () => {
        console.log(`${userType} WebSocket connection closed`);
        setIsConnecting(false);
        runningThis = false;
    };
    client.onmessage = (message) => {

        if (message.data) {

            const msg = JSON.parse(message.data);
            if (msg && msg.message && msg.message.type === 'recognition_started') {
                setIsConnecting(false);
                setStartedSpeaking(true);
                attachAndHandleAudioData(client, scriptProcessor, audioContext);

                console.log("printing coversationId here",msg.message.data.conversationId)
                conversationId.current = msg.message.data.conversationId;

                console.log("Recognition started", interactionType, userType);

                if (interactionType === "HUMAN_TO_HUMAN" && userType === 'customer') {

                    sendConnectedAudio(client);
                }
            }

            if (msg.type === "message" && msg.message.type === "recognition_result") {
                const message = msg.message;
                const name = message.user.name;
                const content = message.punctuated.transcript;
                const isFinal = message.isFinal;
                addMessageToConversation(name, content,setClosedCaption, conversationRef,isFinal);

                if (interactionType === "HUMAN_TO_AI" && isFinal) {
                    setIsCoworkerConnected(true);
                    // Reset the timer on receiving a new final message
                    clearTimeout(messageTimeout);
                    messageTimeout = setTimeout(() => {
                        fetchLLMResponse(setClosedCaption, conversationRef, setData, scriptTitle, callContext, selectedAssistantNames,utteranceRef);
                    }, 2000);
                }
            }

            setData(msg);
        } else {
            console.log("Invalid message received.");
        }
    };

};

const stopWebSocketAndMic = (userType,conversationId) => {
    console.log("Stopping WebSocket and Mic for conversation ID:",conversationId);
    if (audioContext) {
        audioContext.close();
        audioContext = null;
    }
    if (mediaStream) {
        mediaStream.getTracks().forEach(track => track.stop());
        mediaStream = null;
    }
    if (userType === 'customer' && customerClient) {
        customerClient.close();
        customerClient = null;
    }
    if (userType === 'agent') {
        if (agentClient) {
            agentClient.close();
            agentClient = null;
        }
        if (customerClient) {
            customerClient.close();
            customerClient = null;
        }
    }
};

const fetchLLMResponse = async (setClosedCaption, conversationRef, setData, scriptTitle, callContext, selectedAssistantNames,utteranceRef) => {
    console.log("Fetching LLM response...");
    const responseText = await talkToLLM(conversationRef, scriptTitle, callContext, selectedAssistantNames) || "I am sorry, I am unable to respond to you.";
    const llmResponse = responseText || "This is a dummy response from the LLM.";
    addMessageToConversation("customer", llmResponse, setClosedCaption, conversationRef,true);
    const msg = {
        type: "message",
        message: {
            type: "recognition_result",
            isFinal: true,
            user: { name: "Customer" },
            punctuated: { transcript: llmResponse }
        }
    };

    setData(msg);
    playAudio(llmResponse,utteranceRef);
};

const playAudio = (text,utteranceRef) => {
    const synth = window.speechSynthesis;
    const utterance = new SpeechSynthesisUtterance(text);

    utterance.onstart = () => {
        // Mute the microphone
        muteMicrophone(true);
    };

    utterance.onend = () => {
        // Unmute the microphone after playback
        muteMicrophone(false);
    };
    utteranceRef.current = utterance;
    synth.speak(utterance);
};

const muteMicrophone = (mute) => {
    if (mediaStream) {
        mediaStream.getAudioTracks().forEach(track => {
            track.enabled = !mute;
        });
    }
};
let lastIsFinal=true;
const addMessageToConversation = (name, content, setClosedCaption, conversationRef,isFinal) => {

    if (isFinal) {

        if (conversationRef.current.length > 0 && conversationRef.current[conversationRef.current.length - 1].startsWith(`${name}:`)&& lastIsFinal!=isFinal) {
            conversationRef.current.pop();
        }

        const newConversationEntry = `${name}: ${content}`;
        conversationRef.current = [...conversationRef.current, newConversationEntry];
    } else {

        const updatedConversation = [...conversationRef.current];
        if (updatedConversation.length > 0 && updatedConversation[updatedConversation.length - 1].startsWith(`${name}:`)&& lastIsFinal==isFinal) {
            updatedConversation[updatedConversation.length - 1] = `${name}: ${content}`;
        } else {
            updatedConversation.push(`${name}: ${content}`);
        }
        conversationRef.current = updatedConversation;
    }
    lastIsFinal=isFinal;
    setClosedCaption(prevScript => conversationRef.current.map(line => {
        const [speaker, text] = line.split(': ');
        return { speaker, text };
    }));
};

const ShowScript = ({ className, showScriptFn, hideLinkCopiedFn, scriptTitle, onDataReceived, interactionType, scriptSummary, websiteLink, propData, updateStateFromLocation, setFinalConversationId }) => {
    const [isConnecting, setIsConnecting] = useState(false);
    const [parsedScriptSummary, setParsedScriptSummary] = useState(null);
    useEffect(() => {
        try {
            if(scriptSummary) {
                setParsedScriptSummary(scriptSummary);
            }
        } catch (error) {
            console.error("Error parsing JSON:", error);
        }
    }, [scriptSummary]);
    const [isCoworkerConnected, setIsCoworkerConnected] = useState(false);
    const [data, setData] = useState(null);
    const [startedSpeaking, setStartedSpeaking] = useState(false);
    const navigate = useNavigate();
    const conversationRef = useRef([]);
    const [closedCaption, setClosedCaption] = useState([]);
    const [mute, setMute] = useState("Mute");
    let conversationId=useRef("");

    const utteranceRef = useRef(null);
    const selectedAssistantNames = REALTIME_ASSIST_COMPONENTS.reduce((acc, assist) => {
        if (propData.componentsSelectedIds.includes(assist.id)) {
            acc.push(assist.name);
        }
        return acc;
    }, []);

    const handleStartSpeakingButtonClick = async () => {
        setFinalConversationId(null)

        console.log("what is interaction type", interactionType);
        if (!startedSpeaking) {
            setIsConnecting(true);

            await startWebSocketAndMic(setData, setIsConnecting, userType, setClosedCaption, conversationRef, interactionType, scriptTitle, scriptSummary, false, isCoworkerConnected, setIsCoworkerConnected, setStartedSpeaking, selectedAssistantNames,utteranceRef,conversationId);
        } else {
            console.log("in this segment of code under else condition");
            muteMicrophone(false);
            setStartedSpeaking(true);
        }
    };

    const handleCopyButtonClick = async () => {
        const url = new URL(window.location.href);
        let link = url.origin + url.pathname + `?call=${propData.sampleFileSelected}&assistant=${propData.componentsSelectedIds.join(",")}&showscript=true&connectionid=${realtimeSessionId}&usertype=customer&website=${encodeURIComponent(websiteLink)}`;


        // if (!startedSpeaking) {
        //     setIsConnecting(true);
        //     await startWebSocketAndMic(setData, setIsConnecting, userType, setClosedCaption, conversationRef, interactionType, scriptTitle, scriptSummary, true, isCoworkerConnected, setIsCoworkerConnected, setStartedSpeaking, selectedAssistantNames);
        // }

        navigator.clipboard.writeText(link)
            .then(() => {
                hideLinkCopiedFn(false);
                console.log(`Link ${link} is copied to the clipboard`);
            })
            .catch(err => {
                console.error('Failed to copy link: ', err);
            });
    };

    const resetComponent = () => {
        console.log("Reset LLM conversation")
        setIsConnecting(false);
        setIsCoworkerConnected(false);
        setStartedSpeaking(false); // Add a state for the Started Speaking
        conversationRef.current = [];
        setClosedCaption([]); // Add a state for the close caption
        setMute("Mute"); // Add a state for the mute
    }

    const handleBackButtonClick = async () => {
        if (startedSpeaking) {
            await handleStartSpeakingButtonClick();
        }
        if (utteranceRef.current) {
            window.speechSynthesis.cancel();
            utteranceRef.current = null;
        }
        setClosedCaption([]);
        showScriptFn(false);
        resetComponent();
    };

    const handleBackToHomeButtonClick = async () => {
        navigate('/');
        setClosedCaption([]);
        showScriptFn(false);
        resetComponent();
        if (utteranceRef.current) {
            window.speechSynthesis.cancel();
            utteranceRef.current = null; // Clear the reference
        }
    };

    const handleMuteButtonClick = () => {
        if (mute === "Mute") {
            muteMicrophone(true);
            setMute("Unmute");
        } else {
            muteMicrophone(false);
            setMute("Mute");
        }
    };

    const handleEndSessionButtonClick = () => {
        if (startedSpeaking) {
            stopWebSocketAndMic(userType,conversationId);
            console.log("Connection stopped.");

            // Show generate call score button
            console.log('this is conversationId', conversationId)
            setFinalConversationId(conversationId.current)

            setStartedSpeaking(false);
        }
        if (utteranceRef.current) {
            window.speechSynthesis.cancel();
            utteranceRef.current = null;
        }
    };

    const renderClosedCaptions = () => {
        return (
            <>
                {closedCaption.length > 0 && <div className="closed-captions"><b>Transcription:</b></div>}
                {closedCaption.map((line, index) => (
                    <div key={index} className={`script-line ${line.speaker === 'Agent' ? 'agent' : 'customer'}`}>
                        <b>{line.speaker && line.speaker.toUpperCase()}:</b> {line.text}
                    </div>
                ))}
            </>
        );
    };

    useEffect(() => {
        if (data) {
            onDataReceived(data);
        }
    }, [data]);

    useEffect(() => {
        const handleBeforeUnload = () => {
            stopWebSocketAndMic(userType);
        };

        window.addEventListener("beforeunload", handleBeforeUnload);

        return () => {
            window.removeEventListener("beforeunload", handleBeforeUnload);
            if (startedSpeaking) {
                stopWebSocketAndMic(userType);
            }
        };
    }, [startedSpeaking]);

    useEffect(() => {
        const scriptContentDiv = document.querySelector('.script-content');
        if (scriptContentDiv) {
            scriptContentDiv.scrollTop = scriptContentDiv.scrollHeight;
        }
    }, [closedCaption]);


    useEffect(() => {
        const params = new URLSearchParams(location.search);
        if(params && params.size > 0) {
            updateStateFromLocation(params)

            const connectionId = params.get('connectionid');
            const ut = params.get('usertype');

            if (connectionId !== null) {
                realtimeSessionId = connectionId;
                interactionType = "HUMAN_TO_HUMAN";
            }

            if (ut != null && ['customer', 'agent'].includes(ut)) {
                userType = ut;
                console.log("User Type is : ", userType);
            }
        }

    }, [location]);

    return (
        <div className={className}>
            <div className="script-header">
                <div className={"back-button"} onClick={handleBackButtonClick}><ArrowLeftIcon /></div>
                <p className={"script-title"}>{scriptTitle}</p>
                <div className={"home-button"}>
                    <button className={"blue-button"} onClick={handleBackToHomeButtonClick}>
                        <p>Back to Home</p>
                    </button>
                </div>
            </div>
            {closedCaption.length > 0 ? (
                <div className="script-content">
                    {renderClosedCaptions()}
                </div>
            ) : (
                <div className="script-column">
                    {parsedScriptSummary && (
                        <div className="script-summary">
                            {interactionType === "HUMAN_TO_AI" ? (
                                <>
                                    You will play the role of a <b>{scriptTitle}</b> agent and interact with an AI acting as the customer. You can choose to use the following scenario generated based on the context you shared.<br /><br /><br />
                                    <p><b>Scenario: </b>{parsedScriptSummary.scenario}</p>
                                    <p><b>Features: </b>{parsedScriptSummary.features}</p>
                                    <p><b>Use Cases: </b>{parsedScriptSummary.use_cases}</p>
                                </>
                            ) : (
                                <>
                                    You will play the role of a <b>{scriptTitle}</b> agent and interact with a coworker acting as the customer. Invite a coworker to test this with you. You can use the following scenario generated based on the context you shared.<br /><br /><br />
                                    <p><b>Scenario: </b>{parsedScriptSummary.scenario}</p>
                                    <p><b>Features: </b>{parsedScriptSummary.features}</p>
                                    <p><b>Use Cases: </b>{parsedScriptSummary.use_cases}</p>
                                </>
                            )}
                        </div>
                    )}
                </div>
            )}
            {interactionType !== "HUMAN_TO_AI" && (
                <div className="speaker-section">
                    <div className="speakers">
                        <p>{userType === "customer" ? "Customer" : "Agent"}</p>
                        <div className="speaker-name">
                            <div className={"speaker-icon"}><p>Ag</p></div>
                            <p className={"name"}>You are {userType}</p>
                        </div>
                    </div>
                    <div className="communicate-icon">
                        <Communicate />
                    </div>
                    <div className="speakers">
                        <p>{userType === "customer" ? "Agent" : "Customer"}</p>
                        <div className="speaker-name">Invite coworker<Copy className={`copy-icon${isConnecting ? '-disabled' : ''}`} onClick={handleCopyButtonClick} /></div>
                    </div>
                </div>
            )}
            {startedSpeaking && <div className="button-group">
                <button className="white-button button-icon-gap mute-button" title="Mute"
                    onClick={handleMuteButtonClick}>
                    <p>{mute}</p>
                    <MuteIcon />
                </button>
                <button className="red-button button-icon-gap" title="End Session"
                    onClick={handleEndSessionButtonClick}>
                    <p>End Session</p>
                    <EndCallIcon />
                </button>
            </div>}
            {!startedSpeaking && <button className="blue-button button-icon-gap start-speaking" title="Start Speaking"
                onClick={handleStartSpeakingButtonClick} disabled={isConnecting}>
                <p>Start Speaking</p>
                <MicrophoneIcon />
            </button>}
            <div className="script-body">
                {closedCaption.length >= 1 && (
                    <div className="script-column">
                        {parsedScriptSummary && (
                            <div className="script-summary">
                                {interactionType === "HUMAN_TO_AI" ? (
                                    <>
                                        You will play the role of a <b>{scriptTitle}</b> agent and interact with an AI acting as the customer. You can choose to use the following scenario generated based on the context you shared.<br /><br /><br />
                                        <p><b>Scenario: </b>{parsedScriptSummary.scenario}</p>
                                        <p><b>Features: </b>{parsedScriptSummary.features}</p>
                                        <p><b>Use Cases: </b>{parsedScriptSummary.use_cases}</p>
                                    </>
                                ) : (
                                    <>
                                        You will play the role of a <b>{scriptTitle}</b> agent and interact with a coworker acting as the customer. Invite a coworker to test this with you. You can use the following scenario generated based on the context you shared.<br /><br /><br />
                                        <p><b>Scenario: </b>{parsedScriptSummary.scenario}</p>
                                        <p><b>Features: </b>{parsedScriptSummary.features}</p>
                                        <p><b>Use Cases: </b>{parsedScriptSummary.use_cases}</p>
                                    </>
                                )}
                            </div>
                        )}
                    </div>
                )}
            </div>
        </div>
    );
};

export default ShowScript;
